document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#leather-popup--container');
  const buttons = document.querySelectorAll('.button--leather');
  if (!container || buttons.length === 0) return;

  const dialog = container.querySelector('.leather-popup');
  const closeButton = container.querySelector('.popup--close');
  let opener = null;

  const close = () => {
    container.classList.remove('active');
    container.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    opener?.focus();
  };

  const open = (button) => {
    opener = button;
    container.classList.add('active');
    container.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    dialog?.focus();
  };

  buttons.forEach((button) => button.addEventListener('click', () => open(button)));
  closeButton?.addEventListener('click', close);
  container.addEventListener('click', (event) => {
    if (dialog && !dialog.contains(event.target)) close();
  });
  container.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
});
